'use client'

import { useLocale } from 'next-intl'
import { usePathname, useRouter } from '@/i18n/routing'
import { routing } from '@/i18n/routing'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { IconLanguage } from '@tabler/icons-react'
import { useTransition } from 'react'

const localeNames: Record<string, string> = {
  en: 'English',
  ja: '日本語',
  ko: '한국어',
  vi: 'Tiếng Việt',
  id: 'Bahasa Indonesia',
  th: 'ภาษาไทย',
  es: 'Español',
  de: 'Deutsch',
  ru: 'Русский',
  fr: 'Français',
  tr: 'Türkçe'
}

export function LanguageSwitcher() {
  const locale = useLocale()
  const router = useRouter()
  const pathname = usePathname()
  const [isPending, startTransition] = useTransition()

  function onSelectChange(newLocale: string) {
    startTransition(() => {
      router.replace(pathname, { locale: newLocale })
    })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          disabled={isPending}
          className="gap-2"
          aria-label="Change language"
        >
          <IconLanguage className="h-4 w-4" />
          <span className="hidden sm:inline">
            {localeNames[locale] || locale}
          </span>
          <span className="sm:hidden">{locale.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {routing.locales
          .slice()
          .sort((a, b) =>
            (localeNames[a] || a).localeCompare(
              localeNames[b] || b,
              undefined,
              {
                sensitivity: 'base'
              }
            )
          )
          .map((loc) => (
            <DropdownMenuItem
              key={loc}
              onClick={() => onSelectChange(loc)}
              disabled={isPending}
              className={locale === loc ? 'bg-accent' : ''}
            >
              {localeNames[loc] || loc}
              {locale === loc && <span className="ml-auto text-xs">✓</span>}
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
